import axios, { AxiosPromise } from 'axios'

export interface ImpressaoAtendimentoIndividualInput {
  atendimentoId: string
}

export class ImpressaoAtendimentoIndividual {
  imprimirAtendimentoIndividual(input: ImpressaoAtendimentoIndividualInput): AxiosPromise<Blob> {
    return axios.post('/api/atendimento/imprimirAtendimentoIndividual', input, { responseType: 'blob' })
  }
}
